/**
 * Embed de formulários do HubSpot (v2). O script só é carregado quando algum formulário é aberto.
 */

const SCRIPT_URL = 'https://js.hsforms.net/forms/embed/v2.js'

export interface HubspotFormOptions {
  portalId: string
  formId: string
  region?: string
  target: string
  css?: string
  /** Idioma das mensagens nativas do HubSpot (ex.: validação). Não traduz os textos configurados no formulário. */
  locale?: string
  /** Recebe o `<form>` renderizado (ou um objeto jQuery com ele, quando a página tem jQuery). */
  onFormReady?: ($form: any) => void
  onFormSubmitted?: ($form: any) => void
}

export interface HubspotFormsApi {
  create: (options: HubspotFormOptions) => void
}

let loader: Promise<HubspotFormsApi> | null = null

export const loadHubspotForms = (): Promise<HubspotFormsApi> => {
  if (loader) return loader

  loader = new Promise<HubspotFormsApi>((resolve, reject) => {
    const script = document.createElement('script')

    script.src = SCRIPT_URL
    script.async = true
    script.onload = () => {
      const api = (window as any).hbspt?.forms as HubspotFormsApi | undefined

      if (api) resolve(api)
      else reject(new Error('HubSpot carregado sem a API de formulários.'))
    }
    script.onerror = () => {
      script.remove()
      loader = null
      reject(new Error('Não foi possível carregar o formulário do HubSpot.'))
    }

    document.head.appendChild(script)
  })

  return loader
}
